import { render, staticRenderFns } from "./Restrict.vue?vue&type=template&id=2bd12a2e&"
import script from "./Restrict.vue?vue&type=script&lang=js&"
export * from "./Restrict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports